import request from '@/utils/request'
const state = {
  params: {},
  list: [],
  total: 0,
}

const actions = {
  async getPaymentHistories({ commit }, params) {
    const { data } = await request.get('/api/admin/payment-histories', { params })
    if (data?.success) {
      commit('SET_PARAMS', params)
      commit('SET_LIST', data.paymentHistories.docs)
      commit('SET_TOTAL', data.paymentHistories.total)
    }
    return data
  },
}

const mutations = {
  SET_PARAMS(state, params) {
    state.params = { ...params }
  },
  SET_LIST(state, list) {
    state.list = [...list]
  },
  SET_TOTAL(state, total) {
    state.total = total
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
